module.exports = __webpack_public_path__ + "static/one program many outcomes-a449570a9e8ce7c1fc791acc4f2b8f83.svg";